import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import FormDoctorsDirectory from "../components/FormDoctorsDirectory";
// import PaginationSpecialties from "../02-Doctors/PaginationSpecialties";
import AwardsCertifications from "../01-Services/AwardsCertifications";
// import SpecialPackages from "../00-Dashboard/SpecialPackages";
import InsuranceCompanies from "../components/InsuranceCompanies";
import Footer from "../components/Footer";
import { useContext, useState } from "react";
import { ScreenContext } from "../context/ScreenContext";
import CarouselDoctors from "../components/CarouselDoctors";
import { Helmet } from "react-helmet-async";

const MedicalDirectory = () => {
  const { isMobile } = useContext(ScreenContext);
  const [searchResultsDoctors, setSearchResultsDoctors] = useState([]);

  const handleDoctorSearch = (result) => {
    if (Array.isArray(result)) {
      setSearchResultsDoctors(result);
    } else if (result) {
      setSearchResultsDoctors([result]);
    } else {
      setSearchResultsDoctors([]);
    }
  };
  return (
    <>
      <Helmet>
        <title>Directorio de Médicos Especialistas | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Encuentra médicos especialistas en Centro Médico MEDAM. Consulta nuestro directorio médico, especialidades disponibles y profesionales de la salud."
        />
        <meta
          name="keywords"
          content="directorio médico, médicos especialistas, doctores MEDAM, consulta médica, especialistas médicos, Centro Médico MEDAM"
        />
        <meta
          property="og:title"
          content="Directorio de Médicos Especialistas | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="Encuentra especialistas médicos y agenda una consulta en Centro Médico MEDAM."
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta property="og:type" content="website" />
        <link
          rel="canonical"
          href="https://centromedicomedam.com/medicalDirectory"
        />
      </Helmet>
      <Box sx={design.BackGroud}>
        <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text="Directorio de Doctores"
          sx={design.Title}
        >
          Directorio de Doctores
        </CustomText>
      </Box>
      <Grid container sx={design.Container}>
        <Box style={design.div} mt={isMobile ? -20 : -12}>
          <FormDoctorsDirectory
            onSearch={handleDoctorSearch}
            showDropdown={false}
            enableSearch={true}
          />
        </Box>
        <CarouselDoctors colorIcon="#000" cards={searchResultsDoctors} />
      </Grid>
      <AwardsCertifications />
      {/* <SpecialPackages cards={cards} isMobile={isMobile}/> */}
      <InsuranceCompanies />
      <Footer />
    </>
  );
};

export default MedicalDirectory;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    height: "70vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 30,
      sm: 36,
      md: 50,
      lg: 50,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "3%",
  },
  div: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  Container: {
    display: "flex",
    justifyContent: "center",
  },
};
